<div id="content">
  <div class="main-col">
    <ub-card>
      <div title>
        <h1>{{ bookingOption.title }}</h1>
        <h3 *ngIf="state$ | async; let state">{{ state.name }}</h3>
        <div *ngIf="booking.doc.metadata.seatConfirmation?.type">
          <span *ngIf="booking.doc.metadata.seatConfirmation.till && seatExpiration$">
            <span *ngIf="seatExpiration$ | async; let seatExpiration; else expired">
              <ub-label variant="warn">
                <span text i18n>We have allocated you a temporary reservation. This will expire in
                  {{ seatExpiration | easDateFromNow }}
                </span>
              </ub-label>
            </span>
            <ng-template #expired>
              <ub-label variant="warn"
                text="Your temporary reservation has expired. We will check for availability upon submission."
                i18n-text
              >
              </ub-label>
            </ng-template>
          </span>
        </div>

        <div *ngIf="booking.doc.workflow?.expiresAt && stateExpiration$">
          <span *ngIf="stateExpiration$ | async; let stateExpiration; else expired">
            <ub-label variant="warn">
              <span text i18n>This will expire in
                {{ stateExpiration | easDateFromNow }}
              </span>
            </ub-label>
          </span>
          <ng-template #expired>
            <ub-label variant="warn"
              text="Your booking has expired. Please submit your booking again."
              i18n-text
            >
            </ub-label>
          </ng-template>
        </div>
      </div>
      <div actions>
        <div>
          <eas-buttons-list [buttons]="buttons" [processing]="isOperationInProgress"></eas-buttons-list>
        </div>
      </div>
    </ub-card>

    <!--  risr/assess exam  -->
    <div *ngIf="booking.doc.risrAssessExams && booking.doc.risrAssessExams.length > 0">
      <ub-card>
        <h2 title i18n>risr<span style="color: #9efc4b">/</span>assess exams</h2>
        <div content>
          <div class="subtitle-help-text" *ngIf="booking.doc.risrAssessExams.length > 1" i18n>
            Your booking includes multiple exams. You can review each exam’s details below.
          </div>
          <br/>
            <mat-divider></mat-divider>
          <br/>
          <div *ngFor="let risrAssessExam of booking.doc.risrAssessExams; let last = last">
            <eas-risr-assess-exam
              [bookingId]="booking.id"
              [bookingData]="booking.doc.data"
              [risrAssessExam]="risrAssessExam"
              [risrAssessExamType]="bookingOption.bookingItem.examType"
              *ngIf="risrAssessExam">
            </eas-risr-assess-exam>
            <div *ngIf="!last">
              <br/>
              <mat-divider></mat-divider>
              <br/>
            </div>
          </div>
        </div>
      </ub-card>
    </div>

    <!--  Form  -->
    <ub-card>
    <div content *easLoader="loadingState">
        <div *ngIf="easFormGroup$ | async; let easFormGroup">
          <ng-container *ngIf="!isDetailsCollapsed(); else showDetailsTemplate">
            <div style="text-align: right;">
              <button mat-flat-button *ngIf="isDetailCollapsible" color="accent" (click)="isDetailsCollapsed(true)" i18n>Hide
                booking details</button>
            </div>

            <form [formGroup]="easFormGroup.control">
              <div class="form-container">
                <eas-easform-group [easGroup]="easFormGroup"></eas-easform-group>
              </div>
              <ub-button-list>
                <ng-container *ngFor="let transition of transitions$ | async">
                  <button mat-flat-button color="primary" type="button" (click)="doTransition(transition)"
                    [disabled]="isOperationInProgress">{{ transition.name }}</button>
                </ng-container>
                <button *ngIf="!readOnlyGroup" mat-flat-button type="button" (click)="save()" i18n>Save</button>
              </ub-button-list>
            </form>

          </ng-container>
        </div>
      </div>
    </ub-card>

    <div *ngFor="let transaction of transactions; let i = index">
      <eas-payment *ngIf="transaction.role === 'payment' && transaction.state !== TransactionState.Completed" [transaction]="transaction"
        (notification)="onTransactionNotification($event)"></eas-payment>
    </div>

  </div>
  <aside>
    <ub-card fxFlex="1 1 0%">
      <h2 title i18n>Details</h2>
      <div content>
        <p>
          <ub-label label="Booking item" text="{{ bookingOption.bookingItem.name }}" i18n-label></ub-label>
        </p>
        <p>
          <ub-label label="Booking option" text="{{ bookingOption.title }}" i18n-label></ub-label>
        </p>
        <p *ngIf="bookingOption.pricing">
          <ub-label label="Price" text="{{ bookingOption.pricing?.price | currency:bookingOption.pricing?.currency }}" i18n-label></ub-label>
        </p>
        <p *ngIf="bookingOption.summary.bookingDates?.min">
          <ub-label label="Date" i18n-label>
            <span text>{{ bookingOption.summary.bookingDates | easDateRange: timezone: bookingOption.bookingDates?.timezone }}</span>
          </ub-label>
        </p>
        <p *ngIf="bookingOption.summary.bookingWindow?.min">
          <ub-label label="Booking window" i18n-label>
            <span text>{{ bookingOption.summary.bookingWindow | easDateRange: timezone: bookingOption.bookingWindow?.timezone }}</span>
          </ub-label>
        </p>
        <p *ngIf="bookingOption.bookingWindow">
          <ub-label text="{{ getBookingWindowLabel() }}" display="column"></ub-label>
        </p>

        <eas-auditlog [dates]="auditlog$ | async"></eas-auditlog>
      </div>
    </ub-card>
    <div *ngFor="let transaction of transactions; let i = index">
      <eas-payment *ngIf="transaction.role === 'payment' && transaction.state === TransactionState.Completed" [transaction]="transaction"
        (notification)="onTransactionNotification($event)"></eas-payment>
    </div>
  </aside>
</div>

<ng-template #showDetailsTemplate>
  <div style="text-align: right;">
    <button mat-flat-button color="accent" (click)="isDetailsCollapsed(false)" i18n>Show booking details</button>
  </div>
</ng-template>
